import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-navy-base min-h-screen" data-testid="blog-page">
      <SEO title="FutureSkills Knowledge Hub — AI, Careers, Education | XTM TECHNOLOGIES Jorhat"
        description="Articles on AI, data science, cybersecurity, programming, careers, Tally, electronics and skill development from XTM FutureSkills Academy, Jorhat." />
      <section className="relative hero-glow">
        <div className="absolute inset-0 cyber-grid opacity-40" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-orange-400 mb-2">Blog / Resources</div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white" data-testid="blog-heading">FutureSkills Knowledge Hub</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-card border border-white/10 rounded-2xl overflow-hidden hover:border-orange-500/40 transition-colors" data-testid={`blog-card-${p.slug}`}>
              <img src={p.cover} alt={p.title} className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              <div className="p-6">
                <span className="text-[10px] font-bold uppercase tracking-wider text-orange-400 border border-orange-500/40 rounded-full px-2.5 py-1">{p.category}</span>
                <h2 className="font-display text-lg font-semibold text-white mt-3 mb-2 group-hover:text-orange-300 transition-colors">{p.title}</h2>
                <p className="text-sm text-slate-400 line-clamp-2">{p.excerpt}</p>
                <p className="text-xs text-slate-500 mt-4">{new Date(p.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })} • {p.author}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
